import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// User
export const AddNewTicket = async (formData) => {
  return axios.post(`${api.Ticket.savetickit}`, formData);
};

export const GetUserTickets = async (payload) => {
  return axios.post(
    `${api.Ticket.Gettickit}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};


export const SendTicketMessage = async (payload) => {
  return axios.post(
    `${api.Ticket.sendMessage}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};

export const GetTicketMessages = async (ticketId) => {
  return axios.get(
    `${api.Ticket.getMessages}/${ticketId}/messages`
  );
};

export const GetApplications = async () => {
  return axios.get(`${api.Ticket.GET_ALL}`);
};

export const GetModulesByAppId = async (applicationId) => {
  return axios.get(`${api.Ticket.GET_MODULES}?id=${applicationId}`);
};

export const GetSubModulesByModId = async (moduleId) => {
  return axios.get(`${api.Ticket.GET_SUBMODULES}?id=${moduleId}`);
};


export const SendStatuschange = async (requestData) => {

  const payload = {
    data: requestData.data
  };

  console.log("Sending payload:", payload);
  return axios.post(api.Ticket.SendStatuschange, payload);
};

export const approveTicket = async (ticketId, assignedToId) => {
  try {
    const response = await axios.get(
      `${api.Ticket.ApproveTicket}?Id=${ticketId}&approved=true`
    );

    return response?.data?.success === true;
  } catch (error) {
    console.error("Approve API error:", error);
    return false;
  }
};

export const getTicketHistory = async (ticketId) => {
  try {
    const response = await axios.post(
      `${api.Ticket.GetReopenTicketByID}?id=${ticketId}`
    );

    return response.data;
  } catch (error) {
    console.error("History API error:", error);
    return [];
  }
};

export const reassignTicket = async (ticketId, newAssigneeId) => {
debugger
  return axios.post(api.Ticket.ReassignTicket, {
    TicketId: ticketId,
    NewAssignedToId: newAssigneeId
  });
};

export const GetAllTickets = async () => {
  return axios.get(api.Ticket.GetAllTickets);
};